import * as React from 'react';
import CircularProgressbar from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { Col, Row } from 'reactstrap';
import { IProject, IProposition } from 'src/model';
import { Svg } from '../shared/Svg';

const PropositionCardProgressBarColorConfig = {
  accepted: '#1b5ea6',
  initial: '#ffb017',
  refused: '#4d4d4d',
  rejected: '#4d4d4d',
  sent: '#34c8ed',
  shortlisted: '#2e7cff',
  validated: '#1b5ea6',
};

const PropositionCardColorConfig = {
  accepted: 'primary',
  expired: 'dark',
  hidden: 'warning',
  initial: 'warning',
  refused: 'dark',
  rejected: 'dark',
  sent: 'secondary',
  shortlisted: 'info',
  validated: 'primary',
};

const PropositionCardLabelConfig = {
  accepted: 'Clôturé',
  expired: 'Projet assigné',
  hidden: 'Nouvelle proposition reçue',
  initial: 'Nouvelle proposition reçue',
  refused: 'Proposition refusée',
  rejected: 'Proposition rejeté',
  sent: 'Proposition en cours de validation',
  shortlisted: 'Proposition shortlistée',
  validated: 'Proposition envoyée',
};

interface IPropositionCardProps {
  project: IProject;
  proposition: IProposition;
  calculatePercentage: (project: IProject, proposition: IProposition) => number;
}

export const PropositionCard: React.SFC<IPropositionCardProps> = ({
  calculatePercentage,
  project,
  proposition,
}) => {
  return (
    <div
      className='d-flex flex-column justify-content-between rounded position-relative text-dark text-left bg-white p-3 mb-5 border-0'
      style={{ minHeight: '190px' }}
    >
      <Row>
        {proposition.notification && (
          <Svg
            width={32}
            height={32}
            fill='warning'
            src='warning'
            className='position-absolute'
            style={{ top: '-10px', left: '-10px' }}
          />
        )}
        <Col xs='8'>
          <span className='font-weight-bold' style={{ fontSize: '20px' }}>
            {project.title}
          </span>
        </Col>
        <Col
          className='position-absolute'
          style={{ top: '-10px', right: '0px' }}
          xs='4'
        >
          <CircularProgressbar
            percentage={calculatePercentage(project, proposition)}
            strokeWidth={12}
            styles={{
              path: {
                stroke:
                  PropositionCardProgressBarColorConfig[
                    proposition.meta.status
                  ],
              },
              text: {
                fill:
                  PropositionCardProgressBarColorConfig[
                    proposition.meta.status
                  ],
                fontFamily: 'Fredoka One',
                fontSize: '24px',
                fontWeight: 'bold',
                marginTop: '10px',
              },
              trail: {
                fill: '#e7e7e7',
                opacity: 0.5,
              },
            }}
            text={`${calculatePercentage(project, proposition)}%`}
          />
        </Col>
      </Row>
      <Row className='mb-4'>
        <Col xs='6' className='d-flex flex-column'>
          <span
            className='font-weight-bold text-uppercase text-secondary'
            style={{ fontSize: '12px' }}
          >
            Créé le
          </span>
          <span style={{ fontSize: '18px' }}>
            {new Date(project.meta.creationDate).toLocaleDateString()}
          </span>
        </Col>
        <Col xs='6' className='d-flex flex-column'>
          <span
            className='font-weight-bold text-uppercase text-secondary'
            style={{ fontSize: '12px' }}
          >
            Dernière MAJ
          </span>
          <span style={{ fontSize: '18px' }}>
            {new Date(project.meta.lastModified).toLocaleDateString()}
          </span>
        </Col>
      </Row>
      <Row
        className={`position-absolute bg-${
          PropositionCardColorConfig[proposition.meta.status]
        } w-100 p-1`}
        style={{ borderRadius: '0 0 3px 3px', bottom: 0 }}
      >
        <span className='text-uppercase text-white w-100 ml-3'>
          {project.meta.status === 'ended' &&
          proposition.meta.status === 'validated'
            ? 'Clôturé'
            : PropositionCardLabelConfig[proposition.meta.status]}
        </span>
        {project.meta.status === 'ended' &&
          proposition.meta.status === 'validated' && (
            <Svg
              width={18}
              height={18}
              fill={
                proposition.evaluation && proposition.evaluation.evaluationDate
                  ? 'warning'
                  : 'white'
              }
              src='star'
              className='position-absolute'
              style={{ right: '20px' }}
            />
          )}
      </Row>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/PropositionCard.tsx